if (!customElements.get("visual-tabs")) {
  class VisualTabs extends HTMLElement {

    constructor() {
  super();

  this.preSlideId = null;

  this.slider = this.querySelector("slider-component");
  this.tabPanel = this.querySelector("tab-panel");
  if (!this.slider || !this.tabPanel) return;

  this.addEventListener("sliderChanged", this.onSliderChange.bind(this));
  this.addEventListener("item-active", this.onItemActive.bind(this));

  const syncDefaultTab = () => {
    const activeTab = this.tabPanel.querySelector('.tab[aria-selected="true"]');
    if (activeTab) {
      const slideId = activeTab.dataset.slide;
      if (slideId) {
        this.preSlideId = slideId;
        this.slider.slideById(`#${slideId}`);
      }
    }
  };

  // 等待 slider--installed class 出现，说明 install() 已完成
  const observer = new MutationObserver((mutations, obs) => {
    if (this.slider.classList.contains('slider--installed')) {
      obs.disconnect();
      setTimeout(syncDefaultTab, 50); // initPosition 的 transition 结束后
    }
  });

  observer.observe(this.slider, {
    attributes: true,
    attributeFilter: ['class']
  });
}

    onItemActive(event) {
      if (!event?.detail) return;

      const slideId = event.detail.element?.dataset.slide;
      if (slideId === this.preSlideId) return;
      this.preSlideId = slideId;

      if (slideId) this.slider.slideById(`#${slideId}`);
    }

    onSliderChange(event) {
      if (!event?.detail) return;

      const id = event.detail.currentElement?.id;
      if (!id) return;

      const tab = this.tabPanel.querySelector(`.tab[data-slide='${id}']`);
      if (tab) this.tabPanel.switchTab(tab);
    }
  }

  customElements.define("visual-tabs", VisualTabs);
}
